export const PERMIT_ACTIONS = {
  CreateDraft: 'CreateDraft',
  CreateAndSubmit: 'CreateAndSubmit',
  SaveDraft: 'SaveDraft',
  SaveAndSubmit: 'SaveAndSubmit',
  Submit: 'Submit',
  Review: 'Review',
  Approve: 'Approve',
  Reject: 'Reject',
  SaveAndApprove: 'SaveAndApprove',
  EditApproved: 'EditApproved',
  EditInProgress: 'EditInProgress',
  EditFinished: 'EditFinished',
  PerformToolboxTalk: 'PerformToolboxTalk',
  Start: 'Start',
  Prolong: 'Prolong',
  ProlongAndApprove: 'ProlongAndApprove',
  Finish: 'Finish',
  Close: 'Close',
  Copy: 'Copy',
  Delete: 'Delete',
} as const;
